import Lang, { Replacements } from 'lang.js';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

import messages from '@/lang/messages.json';

// Get current locale from Inertia shared data
const currentLocale = computed(() => {
    const page = usePage();
    return (page.props as any)?.locale || 'cs';
});

// Initialize plugin with dynamic locale
const createLangPlugin = () => {
    return new Lang({
        messages: messages,
        locale: currentLocale.value || 'cs',
        fallback: 'cs',
    });
};

export const lang = (key: string, replacements?: Replacements, locale?: string): string => {
    // Create fresh plugin instance to use current locale
    const plugin = createLangPlugin();
    // Use provided locale, current user locale, or fallback to plugin default
    const targetLocale = (typeof locale === 'string' && locale) || currentLocale.value || 'cs';
    return plugin.get(key.replace('/', '.').replace('::', '.'), replacements, targetLocale);
};

export const langHas = (key: string) => {
    const plugin = createLangPlugin();
    return plugin.has(key.replace('/', '').replace('::', '.'));
};

export const langChoice = (key: string, count: number, replacements?: Replacements, locale?: string): string => {
    // Create fresh plugin instance to use current locale
    const plugin = createLangPlugin();
    // Use provided locale, current user locale, or fallback to plugin default
    const targetLocale = (typeof locale === 'string' && locale) || currentLocale.value || 'cs';
    return plugin.choice(key.replace('/', '.').replace('::', '.'), count, replacements, targetLocale);
};
